import React, { useCallback, useLayoutEffect, useRef, useState } from 'react';
import { AppButton, Box, RegularField, Text, useResponsive } from '@common-fe/common-fe';

interface Props {
  isIncorrect: boolean;
  onSubmit: (password: string) => void;
}

const PdfPasswordPrompt: React.FC<Props> = ({ isIncorrect, onSubmit }) => {
  const { isMobile } = useResponsive();
  const [password, setPassword] = useState('');
  const textRef = useRef<HTMLDivElement>(null);
  const [contentWidth, setContentWidth] = useState<number>();

  useLayoutEffect(() => {
    setContentWidth(textRef.current?.offsetWidth);
  }, []);

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      if (password) {
        onSubmit(password);
      }
    },
    [password, onSubmit]
  );

  return (
    <Box
      justify="center"
      align="center"
      width="100%"
      height="100%"
      pad={isMobile ? { horizontal: 'spacing16' } : undefined}
    >
      <Box ref={textRef} align="center" width={isMobile ? '100%' : undefined}>
        <Text data-testid="pdf-document-password-protected" color="textSecondary" textAlign="center">
          This document is password protected.
        </Text>
        <form
          data-testid="pdf-password-prompt_form"
          onSubmit={handleSubmit}
          style={{ width: isMobile ? '100%' : contentWidth }}
        >
          <Box margin={{ top: 'spacing16' }} width="100%">
            <RegularField
              name="pdf-password"
              type="password"
              editMode
              value={password}
              onChange={(value) => setPassword(String(value))}
              placeholder="Password"
              isError={isIncorrect}
              testId="pdf-password-prompt_input"
            />
            {isIncorrect ? (
              <Text data-testid="pdf-password-prompt_error" color="danger" margin={{ top: 'spacing8' }}>
                Incorrect password. Please try again.
              </Text>
            ) : null}
            <Box margin={{ top: 'spacing16' }} width="100%">
              <AppButton width="100%" type="submit" disabled={!password} testId="pdf-password-prompt_submit">
                Submit
              </AppButton>
            </Box>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default PdfPasswordPrompt;
